import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGS } from "../utils/constants";

/**
 * Language selector
 *
 * @param {{ showLabelWhenClosed?: boolean }} props
 *        • showLabelWhenClosed = true  → button shows "🇬🇧 English (UK)"
 *        • showLabelWhenClosed = false → button shows "🇬🇧"   (default)
 */
export default function LangSwitcher({ showLabelWhenClosed = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const activeLanguage = i18n.language || i18n.resolvedLanguage;
  const current =
    LANGS.find((l) => l.code === activeLanguage) ||
    LANGS.find((l) => l.code === i18n.resolvedLanguage) ||
    LANGS[0];

  /** Change language and close pop-up */
  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative">
      {/* closed-state button (flag only) */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="small-outlined-button whitespace-nowrap"
        aria-label="Change language"
      >
        {current.flag} {showLabelWhenClosed && current.label}
      </button>

      {open && (
        <ul
          className="absolute right-0 left-auto mt-1 z-50 bg-white border rounded shadow
                     flex flex-col min-w-[9rem] overflow-hidden"
        >
          {LANGS.map(({ code, label, flag }) => (
            <li key={code}>
              <button
                type="button"
                onClick={() => choose(code)}
                className="flex items-center gap-2 w-full px-3 py-1.5
                           text-left hover:bg-gray-100"
              >
                <span className="text-lg">{flag}</span>
                <span>{label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
